export default __webpack_public_path__ + "static/media/element_63.9116d6eb.jpg";